<!-- HEADER CERTICÁMARA - MINIMALISTA -->
<header class="main-header">
  <!-- Main Navigation -->
  <nav class="main-nav">
    <div class="container">
      <div class="nav-content">
        <!-- Logo y nombre de app (CertiToolWeb) -->
        <a href="/" class="logo" aria-label="CertiTool Web">
          <span class="app-name">CertiTool Web</span>
        </a>

        <!-- Botones de Navegación -->
        <div class="nav-buttons">
          <button 
            class="nav-action-btn sign-btn"
            [class.active]="isSignActive()"
            (click)="goToSign()"
            type="button"
            aria-label="Firmar documentos"
            title="Firmar documentos">
            <img src="assets/icons/signature-icon.svg" alt="Firmar" class="btn-icon-img" />
            <span class="btn-text">Firmar documentos</span>
          </button>
          <button 
            class="nav-action-btn verify-btn"
            [class.active]="isVerifyActive()"
            (click)="goToVerify()"
            type="button"
            aria-label="Verificar documentos"
            title="Verificar documentos">
            <img src="assets/icons/verify-icon.svg" alt="Verificar" class="btn-icon-img" />
            <span class="btn-text">Verificar documentos</span>
          </button>
        </div>

        <!-- Botón Canal de Ventas -->
        <button 
          class="canal-ventas-btn"
          (click)="goToCanalVentas()"
          type="button"
          aria-label="Ir al canal de ventas"
          title="Ir al canal de ventas">
          <mat-icon>store</mat-icon>
          <span class="btn-text">Ir al canal de ventas</span>
        </button>

        <!-- CTA Button -->
        <a href="https://web.certicamara.com/compra-firma" target="_blank" class="cta-button">
          Compra tu firma aquí
        </a>

        <!-- Theme Toggle Button (integrado en el header) -->
        <!-- <app-theme-toggle></app-theme-toggle> -->
      </div>
    </div>
  </nav>
</header>
